export enum CrmItemType {
  STANDARD = 'STANDARD',
  STRUCT_CAP = 'STRUCT_CAP'
}
